module.exports = __webpack_public_path__ + "img/rocket-parts.622d8997.png";